import { useMemo } from 'react';
import { Paragraph, CardName } from 'library/styles/text';
import Colors from 'library/constants/colors';
import {
  Container,
  ImageWrapper,
  ImageOverlay,
  Icon,
} from './styles';

const Image = (color) => (
  <svg fill={color} width="90" height="75" viewBox="0 0 90 75" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} fillRule="evenodd" clipRule="evenodd" d="M10 5H36.8436C39.0896 5 41.06 6.49768 41.6612 8.66178L43.4218 15H5V10C5 7.23858 7.23858 5 10 5ZM0 15V10C0 4.47715 4.47715 0 10 0H36.8436C41.3357 0 45.2765 2.99536 46.4788 7.32356L48.6111 15H80C85.5229 15 90 19.4772 90 25V65C90 70.5229 85.5229 75 80 75H10C4.47715 75 0 70.5229 0 65V20V15ZM5 20V65C5 67.7614 7.23858 70 10 70H80C82.7614 70 85 67.7614 85 65V25C85 22.2386 82.7614 20 80 20H50H5Z" />
  </svg>
);

const SetGrid = ({
  item,
  isSelected,
  onOpen,
  onSelect,
}) => {
  const { color } = item;
  const normalizedColor = color || Colors.violet;
  const image = useMemo(() => Image(normalizedColor.includes('#') ? normalizedColor : `#${normalizedColor}`), []);

  return (
    <Container className={[isSelected && 'selected']} onClick={() => onOpen(item.id)}>
      <ImageWrapper>
        {image}
        <ImageOverlay>
          {onSelect ? <Icon className="icon-check-inverse" onClick={onSelect} /> : null}
          {/* <Icon className="icon-options-vertical" /> */}
        </ImageOverlay>
      </ImageWrapper>
      <CardName>{item.name}</CardName>
      <Paragraph>{`Items: ${(item?.items || []).length}`}</Paragraph>
    </Container>
  );
};

export default SetGrid;
